"use client";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useState } from "react";
import Anchor from "@/components/common/Anchor";
import List from "@/components/common/List";
import type { SecondaryNavLink } from "@/types/nav-bar";
import s from "./SecondaryNavItem.module.scss";

interface SecondaryNavItemProps {
  title: string;
  items: SecondaryNavLink[];
}

export default function SecondaryNavItem(props: SecondaryNavItemProps) {
  const { title, items } = props;
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <li className={s.item}>
      <span onClick={toggleOpen} className={s.button}>
        {title}
        {open ? <RemoveIcon /> : <AddIcon />}
      </span>
      {open && (
        <List
          items={items}
          renderItem={({ text, url, openInNewTab }) => (
            <Anchor href={url} openInNewTab={openInNewTab} extendedURI>
              {text}
            </Anchor>
          )}
          className={s.list}
        />
      )}
    </li>
  );
}
